export default "__VITE_ASSET__b13b64bc__"